import { AnalyticsEventPageView } from './events/recommended'

/**
 * Build page view event including partial determined by canonical path
 */
export const mkAnalyticsPageViewEvent = ({
  canonicalPath,
  pagePath,
}: {
  /** page path with dispensary prefix removed */
  canonicalPath: string
  pagePath: string
}): AnalyticsEventPageView => ({
  ...pageViewEventPartialsByPath[canonicalPath],
  ...(canonicalPath.startsWith('/account')
    ? {
        action: 'account_panel_navigation',
      }
    : {}),
  event: 'page_view',
  page_path: pagePath,
})

/**
 * `page_view` event partials for analytics
 */
const pageViewEventPartialsByPath: {
  [canonicalPath: string]: Partial<AnalyticsEventPageView> | undefined
} = {
  '/account': { parent_menu: 'Account Dashboard', child_menu: 'Account Dashboard' },
  '/account/autoship': { parent_menu: 'My Subscriptions', child_menu: 'My Subscriptions' },
  '/account/dispensary/contact': {
    parent_menu: "Practitioner's Dispensary",
    child_menu: "Practitioner's Dispensary",
  },
  '/account/dispensary/dashboard': {
    parent_menu: 'Virtual Dispensary',
    child_menu: 'Dispensary Dashboard',
  },
  '/account/dispensary/promos': {
    parent_menu: 'Virtual Dispensary',
    child_menu: 'Dispensary Promotions',
  },
  '/account/dispensary/customize/homepage': {
    parent_menu: 'Virtual Dispensary',
    child_menu: 'Customize Home Page',
  },
  '/account/orders': { parent_menu: 'My Purchases', child_menu: 'Orders' },
  '/account/invoices': { parent_menu: 'My Purchases', child_menu: 'Invoices' },
  '/account/reorder': { parent_menu: 'My Purchases', child_menu: 'Reorder Items' },
  '/account/addresses': { parent_menu: 'Billing/Shipping', child_menu: 'Address Book' },
  '/account/credit-cards': { parent_menu: 'Billing/Shipping', child_menu: 'Credit Cards' },
  '/account/transactions': { parent_menu: 'Billing/Shipping', child_menu: 'Invoice History' },
  '/account/settings/dispensing-options': {
    parent_menu: 'Account Settings',
    child_menu: 'Dispensing Options',
  },
  '/account/settings/rewards-program': {
    parent_menu: 'Account Settings',
    child_menu: 'Rewards Program',
  },
  '/account/settings/agreements': { parent_menu: 'Account Settings', child_menu: 'Agreements' },
  '/account/settings/password': { parent_menu: 'Account Settings', child_menu: 'Email & Password' },

  // Missing routes found in Desktop.tsx:
  '/account/settings/rewards-and-dispensing': {
    parent_menu: 'Account Settings',
    child_menu: 'Rewards & Dispensing',
  },
  '/account/rewards/invoices': {
    parent_menu: 'My Rewards',
    child_menu: 'Transactions',
  },
}
